import { Redirect } from "react-router-dom";
import MailTemplateListPage from "../components/layouts/Admin/Plans/MailTemplateListPage";
import AdminLoginScreen from "../components/screens/Admin/Auth/AdminLoginScreen";
import AdminDashboardScreen from "../components/screens/Admin/Dashboard/AdminDashboardScreen";
import AdminInvoiceDetailsScreen from "../components/screens/Admin/Invoice/AdminInvoiceDetailsScreen";
import MailTemplateCreatePage from "../components/screens/Admin/MailTemplate/MailTemplateCreatePage";
import MailTemplateEditPage from "../components/screens/Admin/MailTemplate/MailTemplateEditPage";
import AdminPlanFormScreen from "../components/screens/Admin/Plans/AdminPlanFormScreen";
import AdminPlansDetailsScreen from "../components/screens/Admin/Plans/AdminPlansDetailsScreen";
import AllBannerScreen from "../components/screens/Banner/AllBannerScreen";
import BannerFormScreen from "../components/screens/Banner/BannerFormScreen";
import icons from "../utils/icons";

// Constants
const GUARD = "GUARD";
const BASE = "BASE";
const ADMIN_PREFIX = "/admin";
const DashboardRedirect = () => <Redirect to={`${ADMIN_PREFIX}/dashboard`} />

export const routesPermissionKeys = {
    DASHBOARD: 'Dashboard',
    ROLES: 'Roles',
    VENDORS: 'Vendors',
    PLANS: 'Plans',
    ADMINS: 'Admins',
    REPORTS: 'Reports',
}

export const crudType = {
    canCreate: 'canCreate',
    canRead: 'canRead',
    canUpdate: 'canUpdate',
    canDelete: 'canDelete',
}

function GeneratePathForRoutes(permissionKey, crudType, url, path, type, component, props = {}, config = { key: null, label: null, isShownOnSidebar: false, icon: null }) {
    this.permissionKey = permissionKey
    this.crudType = crudType
    this.url = function (name = '') {
        return url.concat('/', name.split(" ").join("-"))
    };
    this.path = path;
    this.type = type;
    this.label = config.label;
    this.isShownOnSidebar = config.isShownOnSidebar;
    this.key = config.key;
    this.component = component;
    this.props = props;
    this.icon = config.icon
}

const adminPaths = {
    AdminLoginScreen: new GeneratePathForRoutes(null, null, `${ADMIN_PREFIX}/login`, `${ADMIN_PREFIX}/login`, BASE, AdminLoginScreen),

    // dashboard
    AdminDashboardScreen: new GeneratePathForRoutes(routesPermissionKeys.DASHBOARD, crudType.canRead, `${ADMIN_PREFIX}/dashboard`, `${ADMIN_PREFIX}/dashboard`, GUARD, AdminDashboardScreen, {}, { key: "AdminDashboardScreen", label: "Dashboard", isShownOnSidebar: true, icon: icons.DashboardSvg }),

    // Plans
    PlansDetailsScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/offers`, `${ADMIN_PREFIX}/offers`, GUARD, AdminPlansDetailsScreen, {}, { key: "PlansDetailsScreen", label: "Offers", isShownOnSidebar: true, icon: icons.TicketOutlineSvg }),
    AdminPlanCreateScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canCreate, `${ADMIN_PREFIX}/offers/create`, `${ADMIN_PREFIX}/offers/create`, GUARD, AdminPlanFormScreen, { title: 'Create New Offer' }),
    AdminPlanEditScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canUpdate, `${ADMIN_PREFIX}/offers/edit`, `${ADMIN_PREFIX}/offers/edit/:id`, GUARD, AdminPlanFormScreen, { title: 'Edit Offer' }),
    AdminPlanViewScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/offers/view`, `${ADMIN_PREFIX}/offers/view/:id`, GUARD, AdminPlanFormScreen, { title: 'View Offer', readOnly: true }),
    MailTemplateListPage: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/mail-tempate/list`, `${ADMIN_PREFIX}/mail-tempate/list/:offer_identifier`, GUARD, MailTemplateListPage, { title: 'All Mail Templates' }),
    MailTemplateCreatePage: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/mail-tempate/form/create`, `${ADMIN_PREFIX}/mail-tempate/form/create/:offer_identifier`, GUARD, MailTemplateCreatePage, { title: 'Create Mail Template' }),
    MailTemplateEditPage: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/mail-tempate/form/edit`, `${ADMIN_PREFIX}/mail-tempate/form/edit/:id/:offer_identifier`, GUARD, MailTemplateEditPage, { title: 'Edit Mail Template' }),
    MailTemplateViewPage: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/mail-tempate/form/view`, `${ADMIN_PREFIX}/mail-tempate/form/view/:id/:offer_identifier`, GUARD, MailTemplateEditPage, { title: 'View Mail Template', readOnly: true }),

    // Banners
    AllBannerScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/banners`, `${ADMIN_PREFIX}/banners`, GUARD, AllBannerScreen, {}, { key: "AllBannerScreen", label: "Banners", isShownOnSidebar: true, icon: icons.SliderSvg }),
    BannerCreateFormScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canCreate, `${ADMIN_PREFIX}/banners/create`, `${ADMIN_PREFIX}/banners/create`, GUARD, BannerFormScreen, { title: 'Create New Banner' }),
    BannerEditFormScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canUpdate, `${ADMIN_PREFIX}/banners/edit`, `${ADMIN_PREFIX}/banners/edit/:id`, GUARD, BannerFormScreen, { title: 'Edit Banner' }),
    BannerViewFormScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/banners/view`, `${ADMIN_PREFIX}/banners/view/:id`, GUARD, BannerFormScreen, { title: 'View Banner', readOnly: true }),

    AdminInvoiceDetailsScreen: new GeneratePathForRoutes(routesPermissionKeys.DASHBOARD, crudType.canRead, `${ADMIN_PREFIX}/invoice`, `${ADMIN_PREFIX}/invoice`, GUARD, AdminInvoiceDetailsScreen, {}, { key: 'AdminInvoiceDetailsScreen', label: 'Invoices', isShownOnSidebar: true, icon: icons.DashboardSvg }),

    // Gifted
    // GiftedScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/gifted`, `${ADMIN_PREFIX}/gifted`, GUARD, AdminGiftedScreen, {}, { key: "AdminGiftedScreen", label: "Gifted Users", isShownOnSidebar: true, icon: icons.GiftBoxSvg }),
    // GiftedUserViewScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/gifted/view`, `${ADMIN_PREFIX}/gifted/view/:id`, GUARD, AdminGiftedFormScreen, { readOnly: true }),

    // MappedTransaction
    // AdminTransactionDetailedScreen: new GeneratePathForRoutes(routesPermissionKeys.PLANS, crudType.canRead, `${ADMIN_PREFIX}/transaction`, `${ADMIN_PREFIX}/transaction`, GUARD, AdminTransactionDetailedScreen, {}, { key: "AdminTransactionDetailedScreen", label: "Mapped Transactions", isShownOnSidebar: true, icon: icons.BillSvg }),

    // redirect to dashboard
    AdminRedirect: new GeneratePathForRoutes(null, null, `${ADMIN_PREFIX}/`, `${ADMIN_PREFIX}/`, GUARD, DashboardRedirect),
};

// Admin urls
const dashboardUrls = Object.values(adminPaths).filter((each) => each.isShownOnSidebar);
const adminUrls = Object.keys(adminPaths).reduce((obj, item) => Object.assign(obj, { [item]: { url: adminPaths[item].url } }), {});
const baseRoutes = Object.values(adminPaths).filter((each) => each.type === BASE);
const guardRoutes = Object.values(adminPaths).filter((each) => each.type === GUARD);

const adminRoutesConstant = {
    guardRoutes,
    baseRoutes,
    adminUrls,
    adminPaths,
    dashboardUrls,
    ADMIN_PREFIX,
}

export default {
    guardRoutes,
    baseRoutes,
    adminUrls,
    adminPaths,
    dashboardUrls,
    ADMIN_PREFIX,
}